import { DraftAccount } from "@/entities/DataAssociation/Draft.model";
import { StatementType } from "@/entities/DataAssociation/File.model";
import { NormalizedAccount } from "./state";

export type SelectedRow = {
    account: DraftAccount | null;
    rowHeader: string;
    rowIndex: string;
};

export type LabelingContextView =
    | { type: "ACCOUNT_SELECTION_LIST" }
    | { type: "ACCOUNT_LIST_EDIT" }
    | { type: "ACCOUNT_SELECTION_NEW" }
    | { type: "ACCOUNT_EDIT"; initial: NormalizedAccount }
    | { type: "DRAFT_COMMIT" };

export enum AccountAppearanceState {
    DISABLED = "disabled",
    TENTATIVE = "tentative", // used for rows with unconfirmed hints etc.
    DEFAULT = "default",
}

export enum FileStatusOptions {
    UNLABELED = "unlabeled",
    LABELED = "labeled",
    CLEANED = "cleaned",
    ALL = "all",
}

export type FileListStatementType = StatementType | "all";

export const STATEMENT_TYPE_LABELS: Record<FileListStatementType, string> = {
    [StatementType.BALANCE_SHEET]: "Balance sheet",
    [StatementType.INCOME_STATEMENT]: "Income statement",
    [StatementType.MIXED]: "Mixed",
    all: "All statements",
};

export type FileTree = {
    name: string;
    documentKind: StatementType | null;
    date: string;
    id: string;
    draft: {
        id: string;
        status: "committed" | "uncommitted";
        date: string;
    } | null;
    labeledFiles: {
        id: string;
        date: string;
    }[];
};

export type PriorityCategory = "mostRecent" | "historical";
